module.exports = __webpack_public_path__ + "img/wind_speed.838260a2.svg";